import React from 'react'
import ReactSelect from '../../components/Select';
import { connect } from 'react-redux';

const SelectParent1 = ({ onSelected, label, persons }) => (
    <ReactSelect onSelected={onSelected} options={persons} label={label} />
);
export default connect(state => {
    return {
        persons: state.persons.map(pers => ({
            value: pers.uid,
            label: pers.name,
        })),
    };
})(SelectParent1);